import { connect } from 'react-redux';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'styled-components';

import CSSTransitionOnMount from 'presentation/components/lib/CSSTransitionOnMount';
import { getIsNavigatingBack, getSelectedSelfServiceAnswer } from 'app/modules';
import overrideStyle from 'lib/overrideStyle';
import StyledHtmlBody from './StyledHtmlBody';

export function AnswerDisplay({ body, isNavigatingBack, name }) {
  return (
    <CSSTransitionOnMount className="gladlySelfService-answerFade" timeout={300}>
      <Answer data-aid="selfService-answerDisplay" isNavigatingBack={isNavigatingBack} tabIndex="0">
        <InnerWrapper tabIndex="-1">
          <Title>{name}</Title>
          <StyledHtmlBody body={body} />
        </InnerWrapper>
      </Answer>
    </CSSTransitionOnMount>
  );
}

const Answer = overrideStyle('div')`
  display: flex;
  flex-direction: column;
  opacity: 0;
  overflow-y: auto;
  transform: translate3d(0, 0, 0);

  &.gladlySelfService-answerFade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }
  &.gladlySelfService-answerFade-enter-done {
    opacity: 1;
  }

  ${p => !p.isNavigatingBack && translateAnswer}
`;

const InnerWrapper = overrideStyle('div')`
  outline: none;
`;

const translateAnswer = css`
  transform: translate3d(20px, 0, 0) !important;

  &.gladlySelfService-answerFade-enter-active {
    transition: opacity 300ms ease-in, transform 300ms ease-in !important;
    transform: translate3d(0, 0, 0) !important;
  }
  &.gladlySelfService-answerFade-enter-done {
    transform: translate3d(0, 0, 0) !important;
  }
`;

const Title = overrideStyle('div')`
  flex-shrink: 0;
  font-family: ${p => p.theme.fontLibrary.primary};
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 20px;
  padding: 0 35px;
`;

AnswerDisplay.propTypes = {
  body: PropTypes.string,
  name: PropTypes.string,
};

const mapStateToProps = state => {
  let selectedAnswer = getSelectedSelfServiceAnswer(state);

  return {
    body: get(selectedAnswer, 'bodyHtml'),
    isNavigatingBack: getIsNavigatingBack(state),
    name: get(selectedAnswer, 'name'),
  };
};

export default connect(mapStateToProps)(AnswerDisplay);
